const UserState = {
    users: [],
    loading: false,
    error:false,
    user: null,
}

export default UserState;
